import styled from "styled-components";

export const SubtitleEditContainerSC = styled.div`
  background-color: #fff;
  padding: 0 10px 10px 10px;
  border-radius: 0 0 8px 8px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  width: 100%;
  display: flex;
  flex-direction: column;
  height: 100%;
  position: relative;
  flex: 1;
  overflow: hidden;
`;

export const SubtitleWrapperSC = styled.div`
  overflow: auto;
`;

export const LineSC = styled.div`
  width: 100%;
  height: 10px;
  cursor: row-resize;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  border-top: 1px solid black;
  border-bottom: 1px solid black;
  background: #fff;
  z-index: 1;
`;
